import React from 'react';
import { PropTypes } from 'prop-types';
import TextInput from '../TextInput/TextInput';

const ValidatedInput = ({
  name, value, onChange, error = null, clearError = () => { },
}) => {
  if (error) {
    const isEmptyFieldError = error.includes('must be at least 1 character long');
    return (
      <>
        <TextInput
          name={name}
          value={value}
          onChange={(e) => {
            onChange(e);
            clearError();
          }}
          isValid={false}
          errorMessage={isEmptyFieldError ? error : undefined} // For empty input
          validationError={!isEmptyFieldError ? error : undefined} // For duplicated inputs
          isRequired
        />
      </>
    );
  }
  return (
    <TextInput
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export default ValidatedInput;

// Prop types for component props validation
ValidatedInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  clearError: PropTypes.func,
};
